(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9-]/g, '');
    cents = Number(cents || 0);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var nums = (Math.abs(number) / 100.0).toFixed(precision).split('.');
      var dollars = nums[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return (number < 0 ? '-' : '') + dollars + (nums[1] ? decimal + nums[1] : '');
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function optionData(el) {
    if (!el) return null;
    var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
    if (!opt) return null;
    return {
      id: opt.value,
      price: Number(opt.getAttribute('data-price') || 0),
      compare: Number(opt.getAttribute('data-compare') || 0),
      image: opt.getAttribute('data-image') || '',
      available: opt.getAttribute('data-available') !== 'false',
    };
  }

  function hideSellyBundle() {
    if (!document.body || String(document.body.getAttribute('data-template') || '') !== 'product.mg5') return;
    document.querySelectorAll('.tdf_bundle').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  function createBundleSwiper(root) {
    var carouselEl = root.querySelector('.mg5-bundlesale__carousel');
    var paginationEl = root.querySelector('.mg5-bundlesale__pagination');
    if (!carouselEl) return;
    if (!window.Swiper) {
      window.addEventListener('load', function () {
        createBundleSwiper(root);
      }, { once: true });
      return;
    }
    if (carouselEl.swiper && typeof carouselEl.swiper.destroy === 'function') {
      try {
        carouselEl.swiper.destroy(true, true);
      } catch (err) {
        /* ignore stale instance */
      }
    }
    new Swiper(carouselEl, {
      slidesPerView: 2,
      spaceBetween: 8,
      watchOverflow: false,
      threshold: 10,
      simulateTouch: true,
      grabCursor: true,
      preventClicks: false,
      preventClicksPropagation: false,
      noSwiping: true,
      noSwipingSelector: 'select',
      navigation: {
        nextEl: root.querySelector('.mg5-bundlesale__nav--next'),
        prevEl: root.querySelector('.mg5-bundlesale__nav--prev'),
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        750: { slidesPerView: 2, spaceBetween: 16 },
        990: { slidesPerView: 3, spaceBetween: 24 },
        1200: { slidesPerView: 4, spaceBetween: 24 },
      },
    });
  }

  function initSection(root) {
    if (!root) return;
    hideSellyBundle();
    createBundleSwiper(root);
    if (root.dataset.mg5bBound) return;
    root.dataset.mg5bBound = 'true';

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var sectionDiscount = Number(root.getAttribute('data-discount-percent') || 20);
    var saveLabel = root.getAttribute('data-save-label') || 'SAVE';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mg5b-card]'));
    var bar = root.querySelector('[data-mg5b-bar]');
    var pairImg = root.querySelector('[data-mg5b-pair-img]');
    var pairTitle = root.querySelector('[data-mg5b-pair-title]');
    var pairVariantLabel = root.querySelector('[data-mg5b-pair-variant-label]');
    var totalEl = root.querySelector('[data-mg5b-total]');
    var totalCompareEl = root.querySelector('[data-mg5b-total-compare]');
    var saveEl = root.querySelector('[data-mg5b-save]');
    var atc = root.querySelector('[data-mg5b-atc]');
    var mainSelect = root.querySelector('[data-mg5b-main-variant]');
    var mainImg = root.querySelector('[data-mg5b-main-img]');
    var selectedCard = root.querySelector('[data-mg5b-card].is-selected');

    function selectedPairData() {
      if (!selectedCard) return null;
      return optionData(selectedCard.querySelector('[data-mg5b-pair-variant]'));
    }

    function selectedVariantLabel(el) {
      if (!el) return '';
      var label = '';
      if (el.tagName === 'SELECT') {
        var opt = el.options[el.selectedIndex];
        label = opt ? (opt.text || '').trim() : '';
      } else {
        label = (el.getAttribute('data-label') || '').trim();
      }
      if (!label || label.toLowerCase() === 'default title') return '';
      return label;
    }

    function setSelected(card) {
      selectedCard = card || null;
      cards.forEach(function (item) {
        var on = item === selectedCard;
        item.classList.toggle('is-selected', on);
        var btn = item.querySelector('[data-mg5b-toggle]');
        if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      updateBar();
    }

    function updateCardPrice(card) {
      var data = optionData(card.querySelector('[data-mg5b-pair-variant]'));
      if (!data) return;
      var priceEl = card.querySelector('[data-mg5b-card-price]');
      var compareEl = card.querySelector('[data-mg5b-card-compare]');
      var img = card.querySelector('.mg5-bundlesale__card-img');
      if (priceEl && !priceEl.hasAttribute('data-mg5b-custom-price')) {
        priceEl.innerHTML = formatMoney(data.price, moneyFormat);
      }
      if (compareEl && !compareEl.hasAttribute('data-mg5b-custom-compare')) {
        var showCompare = data.compare > data.price;
        compareEl.innerHTML = showCompare ? formatMoney(data.compare, moneyFormat) : '';
        compareEl.classList.toggle('is-hidden', !showCompare);
      }
      if (img && data.image) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = data.image;
      }
    }

    function updateBar() {
      var main = optionData(mainSelect);
      var pair = selectedPairData();
      if (bar) bar.classList.toggle('is-empty', !pair);

      if (pair) {
        var pairName = selectedCard ? selectedCard.getAttribute('data-title') || '' : '';
        if (pairImg) {
          pairImg.src = pair.image || '';
          pairImg.alt = pairName;
        }
        if (pairTitle) pairTitle.textContent = pairName;
        if (pairVariantLabel) {
          var label = selectedVariantLabel(selectedCard.querySelector('[data-mg5b-pair-variant]'));
          pairVariantLabel.textContent = label;
          pairVariantLabel.classList.toggle('is-hidden', !label);
        }
      } else if (pairVariantLabel) {
        pairVariantLabel.textContent = '';
        pairVariantLabel.classList.add('is-hidden');
      }

      if (!main) return;
      var original = main.price + (pair ? pair.price : 0);
      var current = original;
      var percent = sectionDiscount;
      if (selectedCard && selectedCard.getAttribute('data-discount-percent') != null) {
        percent = Number(selectedCard.getAttribute('data-discount-percent'));
      }
      if (percent > 0 && pair) {
        current = Math.round((original * (100 - percent)) / 100);
      }
      var save = Math.max(0, original - current);

      if (totalEl) totalEl.innerHTML = formatMoney(current, moneyFormat);
      if (totalCompareEl) {
        totalCompareEl.innerHTML = original > current ? formatMoney(original, moneyFormat) : '';
        totalCompareEl.classList.toggle('is-hidden', original <= current);
      }
      if (saveEl) {
        saveEl.innerHTML = saveLabel + ' ' + formatMoney(save, moneyFormat);
        saveEl.classList.toggle('is-hidden', save <= 0 || !pair);
      }
      if (atc) {
        var canAdd = !!(main && pair && main.available && pair.available);
        atc.toggleAttribute('disabled', !canAdd);
        atc.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
      }
    }

    var carouselEl = root.querySelector('.mg5-bundlesale__carousel');
    var selectInteraction = null;

    function getSwiper() {
      return carouselEl && carouselEl.swiper && !carouselEl.swiper.destroyed ? carouselEl.swiper : null;
    }

    function snapshotHorizontalScroll(el) {
      var positions = [];
      var node = el;
      while (node && node !== document.body) {
        positions.push({ node: node, left: node.scrollLeft });
        if (node === root) break;
        node = node.parentElement;
      }
      return positions;
    }

    function restoreSelectPosition() {
      if (!selectInteraction) return;

      selectInteraction.scrollPositions.forEach(function (position) {
        position.node.scrollLeft = position.left;
      });

      var currentSwiper = getSwiper();
      if (currentSwiper) {
        currentSwiper.slideTo(selectInteraction.activeIndex, 0, false);
      }
    }

    function beginSelectInteraction(event) {
      event.stopPropagation();
      var currentSwiper = getSwiper();
      selectInteraction = {
        activeIndex: currentSwiper ? currentSwiper.activeIndex : 0,
        scrollPositions: snapshotHorizontalScroll(event.currentTarget),
      };

      if (currentSwiper) {
        currentSwiper.allowTouchMove = false;
        if (currentSwiper.touchEventsData) {
          currentSwiper.touchEventsData.isTouched = false;
          currentSwiper.touchEventsData.isMoved = false;
          currentSwiper.touchEventsData.startMoving = false;
        }
      }

      restoreSelectPosition();
      requestAnimationFrame(restoreSelectPosition);
    }

    function endSelectInteraction(event) {
      if (event) event.stopPropagation();
      restoreSelectPosition();
      requestAnimationFrame(restoreSelectPosition);
      setTimeout(restoreSelectPosition, 50);
      setTimeout(function () {
        restoreSelectPosition();
        var currentSwiper = getSwiper();
        if (currentSwiper) currentSwiper.allowTouchMove = true;
        selectInteraction = null;
      }, 200);
    }

    root.addEventListener('scroll', function () {
      if (selectInteraction) restoreSelectPosition();
    }, true);

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-mg5b-pair-variant], [data-mg5b-product-link]')) return;
        if (card.classList.contains('is-selected') && event.target.closest('[data-mg5b-toggle]')) {
          setSelected(null);
          return;
        }
        setSelected(card);
      });

      var variantEl = card.querySelector('[data-mg5b-pair-variant]');
      if (variantEl && variantEl.tagName === 'SELECT') {
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
          variantEl.addEventListener(type, beginSelectInteraction);
        });
        ['pointerup', 'mouseup', 'touchend', 'click'].forEach(function (type) {
          variantEl.addEventListener(type, function (event) {
            event.stopPropagation();
            restoreSelectPosition();
          });
        });
        variantEl.addEventListener('change', function (event) {
          endSelectInteraction(event);
          updateCardPrice(card);
          if (card === selectedCard) updateBar();
        });
        variantEl.addEventListener('blur', endSelectInteraction);
      }
    });

    var removeBtn = root.querySelector('[data-mg5b-remove]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setSelected(null);
      });
    }

    if (mainSelect) {
      mainSelect.addEventListener('change', function () {
        var data = optionData(mainSelect);
        if (mainImg && data && data.image) mainImg.src = data.image;
        updateBar();
      });
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant || !mainSelect) return;
        if (mainSelect.tagName === 'SELECT') {
          mainSelect.value = String(variant.id);
          mainSelect.dispatchEvent(new Event('change'));
        }
      });
    }

    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.hasAttribute('disabled') || atc.getAttribute('aria-disabled') === 'true') return;
        var main = optionData(mainSelect);
        var pair = selectedPairData();
        if (!main || !pair) return;

        var spinner = atc.querySelector('.loading__spinner');
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

        atc.setAttribute('aria-disabled', 'true');
        atc.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        var payload = {
          items: [
            { id: Number(main.id), quantity: 1 },
            { id: Number(pair.id), quantity: 1 },
          ],
        };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map(function (section) {
            return section.id;
          }).join(',');
          payload.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) throw new Error(response.description || 'Add to cart failed');
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'mg5-bundlesale',
                cartData: response,
              });
            }
            if (!cart) {
              window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              return;
            }
            if (typeof cart.renderContents === 'function') {
              cart.classList.remove('is-empty');
              cart.renderContents(response);
              return;
            }
            if (typeof cart.open === 'function') cart.open();
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            atc.classList.remove('loading');
            atc.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      });
    }

    updateBar();
  }

  function initAll() {
    hideSellyBundle();
    document.querySelectorAll('[data-mg5-bundlesale]').forEach(initSection);
    setTimeout(hideSellyBundle, 800);
    setTimeout(hideSellyBundle, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mg5-bundlesale]');
    if (root) initSection(root);
  });
})();
